import React, { useContext } from 'react';

export const LanguageContext = React.createContext('de');

/**
 * @brief Component to use localized texts depending on defined language
 */
export const Localized = ({ en, de }) => {
    const lang = useContext(LanguageContext);

    if (lang === 'en') {
        return en;
    }

    return de;
};

/**
 * @brief Hook to use localized strings depending on defined language
 */
export function useLocalizedString({ de, en }) {
    const lang = useContext(LanguageContext);

    if (lang === 'en') {
        return en;
    }

    return de;
}

/**
 * @brief Hook to return the defined language
 */
export function useLanguage() {
    return useContext(LanguageContext);
}
